import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { Project } from "@/types";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export type GenerateSigningKeyResponse = {
  project: Project;
  privateKeyPem: string;
  privateKeyBase64: string;
};

export const useGenerateSigningKey = (
  projectId: string,
  options: Omit<UseMutationOptions<GenerateSigningKeyResponse, UnprocessableEntityError, void, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<GenerateSigningKeyResponse, UnprocessableEntityError, void, unknown>({
    mutationFn: async (): Promise<GenerateSigningKeyResponse> => {
      const response = await api.post<GenerateSigningKeyResponse>(`/projects/${projectId}/generate-signing-key`);
      return camelize(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId],
      });
      queryClient.invalidateQueries({
        queryKey: ["projects"],
      });
    },
    ...options
  });
};
